export const environment = {
    shopId: 'ChIJX60x74wrckERdjt7ryE9KNI',
    useEmulators: false,
    isAdminPage: false,
    firebaseConfig: {
        apiKey: "AIzaSyDwhZRvp1I6tocJ_xNq5lQxVtoeqjF5RNY",
        authDomain: "flora1-productsuite.firebaseapp.com",
        projectId: "flora1-productsuite",
        storageBucket: "flora1-productsuite.appspot.com",
        messagingSenderId: "215439907480",
        appId: "1:215439907480:web:6b5ebfda0167dbf7874eed",
        measurementId: "G-0HPKXMF5CK"
    }
};